import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import "./ErrorBanner.scss";

const ErrorBanner = ({
  errors,
  title = "ERROR! - Below errors detected, which may cause incorrect reporting",
}) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  return (
    <div className="error-banner">
      <div className="error-banner-content">
        <div className="error-banner-header">
          <ExclamationCircleOutlined className="error-icon" />
          <span className="error-title">{title}</span>
        </div>
        <div className="error-banner-messages">
          {errors.map((error, index) => (
            <div key={index} className="error-message">
              <span className="error-bullet">•</span>
              <span className="error-text">{error}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ErrorBanner;
